export default __webpack_public_path__ + "static/media/gambrel.cc8de4a3.png";